import type { Monaco } from '@monaco-editor/react';

export const defineMonacoTheme = (monaco: Monaco) => {
  monaco.editor.defineTheme('custom-dark', {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'keyword', foreground: '16A34A' },
      { token: 'identifier', foreground: 'FFFFFF' },
      { token: 'string', foreground: 'FFFFFF' },
      { token: 'number', foreground: 'FFFFFF' },
    ],
    colors: {
      'editor.background': '#0F0F0F',
    },
  });

  monaco.editor.defineTheme('custom-light', {
    base: 'vs',
    inherit: true,
    rules: [
      { token: 'keyword', foreground: '16A34A' },
      { token: 'identifier', foreground: '030303' },
    ],
    colors: {
      'editor.background': '#FFFFFF',
    },
  });
};
